import { render, staticRenderFns } from "./lrp-retailer.vue?vue&type=template&id=2f8f55c0"
import script from "./lrp-retailer.vue?vue&type=script&lang=js"
export * from "./lrp-retailer.vue?vue&type=script&lang=js"
import style0 from "./lrp-retailer.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports